import { z } from "zod";

/**
 * The closed set of colour names an agent definition may declare.
 *
 * Anthropic's own list, and not ours to extend: Claude Code validates a
 * definition's `color:` frontmatter key against exactly these eight and drops
 * anything else in silence, so a definition saying `color: green` means the same
 * thing in a terminal and in the chat. A ninth name here would paint an agent a
 * colour the tool that owns the vocabulary refuses to paint.
 *
 * It lives in the chat kernel because both sides of the boundary need it — the
 * wire events carrying a dispatch, and the persisted tool-call part a reopened
 * conversation renders from.
 */
export const AGENT_COLOUR_NAMES = [
  "red",
  "blue",
  "green",
  "yellow",
  "purple",
  "orange",
  "pink",
  "cyan"
] as const;

export const AgentColourNameSchema = z.enum(AGENT_COLOUR_NAMES);

export type AgentColourName = z.infer<typeof AgentColourNameSchema>;
